/*
MIT LICENSE
Copyright (c) 2020-present Alibaba Cloud Design
Copied from antd/lib/date-picker/generatePicker/generateRangePicker.tsx
Copyright (c) 2015-present Ant UED, https://xtech.antfin.com/

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE. */
import React from 'react';
import classNames from 'classnames';
import { RangePicker as RCRangePicker } from 'rc-picker';
import zhCN from 'antd/lib/date-picker/locale/zh_CN';
import { ConfigContext } from '../../config-provider';
import { withConfigProvider } from '../../config-provider/util';
import warning from 'antd/es/_util/warning';
import SizeContext from '../../config-provider/SizeContext';
import LocaleReceiver from 'antd/lib/locale-provider/LocaleReceiver';
import { getRangePlaceholder } from 'antd/lib/date-picker/util';
import { getTimeProps, Components } from '.';
import { Icon } from '../../icon';
import { getDropdownClassName, getIcons } from './_util';
export default function generateRangePicker(generateConfig) {
    class RangePicker extends React.Component {
        static contextType = ConfigContext;
        pickerRef = React.createRef();
        focus = () => {
            if (this.pickerRef.current) {
                this.pickerRef.current.focus();
            }
        };
        blur = () => {
            if (this.pickerRef.current) {
                this.pickerRef.current.blur();
            }
        };
        renderPicker = (contextLocale) => {
            const locale = { ...contextLocale, ...this.props.locale };
            const { getPrefixCls, direction, getPopupContainer, animation } = this.context;
            const { prefixCls: customizePrefixCls, getPopupContainer: customGetPopupContainer, className, size: customizeSize, bordered = true, placeholder, dropdownClassName, ...restProps } = this.props;
            const { format, showTime, picker } = this.props;
            const prefixCls = getPrefixCls('picker', customizePrefixCls);
            if (process.env.NODE_ENV !== 'production')
                warning(!('theme' in this.props), 'date-picker', `'themes' is deprecated now`);
            warning(bordered !== false, 'date-picker', `'bordered = false' is deprecated now`);
            let additionalOverrideProps = {};
            additionalOverrideProps = {
                ...additionalOverrideProps,
                ...(showTime ? getTimeProps({ format, picker, ...showTime }) : {}),
                ...(picker === 'time' ? getTimeProps({ format, ...this.props, picker }) : {})
            };
            const rootPrefixCls = getPrefixCls();
            return (React.createElement(SizeContext.Consumer, null, (size) => {
                const mergedSize = customizeSize || size;
                return (React.createElement(RCRangePicker, { separator: React.createElement("span", { "aria-label": 'to', className: `${prefixCls}-separator` },
                        React.createElement(Icon, { type: 'subtract' })), ref: this.pickerRef, placeholder: getRangePlaceholder(picker, locale, placeholder), ...getIcons(picker), dropdownClassName: getDropdownClassName(dropdownClassName, prefixCls, animation), allowClear: true, transitionName: `${rootPrefixCls}-slide-up`, ...restProps, ...additionalOverrideProps, className: classNames({
                        [`${prefixCls}-${mergedSize}`]: mergedSize,
                        [`${prefixCls}-bdesign`]: true
                    }, className), locale: locale.lang, prefixCls: prefixCls, getPopupContainer: customGetPopupContainer || getPopupContainer, generateConfig: generateConfig, components: Components, direction: direction, bordered: true }));
            }));
        };
        render() {
            return (React.createElement(LocaleReceiver, { componentName: 'DatePicker', defaultLocale: zhCN }, this.renderPicker));
        }
    }
    return withConfigProvider(RangePicker);
}
